import { render, staticRenderFns } from "./PromptFooter.vue?vue&type=template&id=06c33dfe&scoped=true&"
import script from "./PromptFooter.vue?vue&type=script&lang=js&"
export * from "./PromptFooter.vue?vue&type=script&lang=js&"
import style0 from "./PromptFooter.vue?vue&type=style&index=0&id=06c33dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c33dfe",
  null
  
)

export default component.exports